import { render, staticRenderFns } from "./ClientCareLog.vue?vue&type=template&id=8d9cf4be&scoped=true"
import script from "./ClientCareLog.vue?vue&type=script&lang=ts"
export * from "./ClientCareLog.vue?vue&type=script&lang=ts"
import style0 from "./ClientCareLog.vue?vue&type=style&index=0&id=8d9cf4be&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9cf4be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d9cf4be')) {
      api.createRecord('8d9cf4be', component.options)
    } else {
      api.reload('8d9cf4be', component.options)
    }
    module.hot.accept("./ClientCareLog.vue?vue&type=template&id=8d9cf4be&scoped=true", function () {
      api.rerender('8d9cf4be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/project/ClientCareLog.vue"
export default component.exports